import styled from 'styled-components'

import { Modal as BootstrapModal } from 'react-bootstrap'

export const Modal = styled(BootstrapModal)`
  .modal-dialog {
    .modal-content {
      box-shadow: none;
      border-radius: 4px;
      max-width: 1200px;
    }
  }
`
